export const COLOR_PALEETTE = {
  BLACK: '#424C55',
  GRAY: '#f5f5f5',
  ORANGE: '#ff8811',
  WHITE: '#ffffff',
};
